module.exports = __webpack_public_path__ + "img/manifoldgarden.jpg.d91f66fb.webp";